/**
 * Created by PuTi(编程即菩提) 3/22/17.
 */
var Bind = function (inName,inOpts) {
    this.name = inName;
    this.opts = inOpts;
};

module.exports = function (nb) {
    nb.Bind = Bind;
    nb.bind = function(inName,inOpts){
        return new Bind(inName,inOpts);
    };
};


//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/core/bind.js
// module id = 210
// module chunks = 35